import {useUser} from "../State/UserContext";
import {Navigate} from "react-router-dom";
import ROUTES from "../../route";

const ProtectedRoute = ({children, requiredRole}) => {
    const {user} = useUser();

    const role = {
        'admin' : 1,
        'user' : 2
    }

    if (!user) {
        return <Navigate to={ROUTES.DEFAULT} replace />
    }

    if (requiredRole && user.role_id !== role[requiredRole]) {
        return <Navigate to={ROUTES.DEFAULT} replace />
    }

    return children;
}

export default ProtectedRoute;
